import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Lookup from "./pages/Lookup";
import Submit from "./pages/Submit";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Portal from "./pages/Portal";
import Admin from "./pages/Admin";
import PaymentResult from "./pages/PaymentResult";
import PackingSlip from "./pages/PackingSlip";
import AdminReceive from "./pages/AdminReceive";
import About from "./pages/About";
import Process from "./pages/Process";
import Standard from "./pages/Standard";
import GradingScale from "./pages/GradingScale";
import CardGrades from "./pages/CardGrades";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Press from "./pages/Press";
import WhyMas from "./pages/WhyMas";
import Compare from "./pages/Compare";
import WitnessedCert from "./pages/WitnessedCert";
import GradingGuide from "./pages/GradingGuide";
import Kiosk from "./pages/Kiosk";
import Convention from "./pages/Convention";
import ConventionLabel from "./pages/ConventionLabel";

function Protected({ children, admin, staff }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-neutral-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/portal" replace />;
  if (staff && !["staff", "admin"].includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}

function Shell() {
  return (
    <div className="App">
      <Navbar />
      <div className="relative z-10">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/lookup" element={<Lookup />} />
          <Route path="/lookup/:certnum" element={<Lookup />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/portal" element={<Protected><Portal /></Protected>} />
          <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          <Route path="/packing-slip/:id" element={<Protected><PackingSlip /></Protected>} />
          <Route path="/admin/receive/:id" element={<Protected admin><AdminReceive /></Protected>} />
          <Route path="/about" element={<About />} />
          <Route path="/process" element={<Process />} />
          <Route path="/standard" element={<Standard />} />
          <Route path="/grading-scale" element={<GradingScale />} />
          <Route path="/card-grades" element={<CardGrades />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/press" element={<Press />} />
          <Route path="/why-mas" element={<WhyMas />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/witnessed-certification" element={<WitnessedCert />} />
          <Route path="/trading-card-grading" element={<GradingGuide />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="light" position="top-right" richColors />
        <Routes>
          <Route path="/kiosk" element={<Kiosk />} />
          <Route path="/convention" element={<Protected staff><Convention /></Protected>} />
          <Route path="/convention/label/:id" element={<Protected staff><ConventionLabel /></Protected>} />
          <Route path="/*" element={<Shell />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
